import React from 'react';
import ReactDOM from 'react-dom';
import PromoVideoInfoModal from './components/PromoVideoInfoModal';
import { fetchData } from '../../helpers/base_data_fetcher';

const promotedAd = document.getElementsByClassName(
  'listing-card__promoted-video-info',
);

const mountElement = document.getElementById('promotedVideoInfoModal');

export default function promoVideoInfoModal() {
  if (mountElement && promotedAd.length) {
    Promise.all([fetchData('page'), fetchData('localisations')]).then(
      ([page, localisations]) => {
        ReactDOM.render(
          <PromoVideoInfoModal
            localisations={localisations.search_results}
            loginReturnPath={page.loginReturnPath}
          />,
          mountElement,
        );
      },
    );
  }
}
